import React from "react";
import PropTypes from "prop-types";
import OfflineIcon from "./OfflineIcon";

import { AlertCircleFilled } from '@sainsburys-tech/icons'

const statuses = ["success", "warning", "error"];
const icons = ["offline", "error"];

const icon = iconName => {
  switch (iconName) {
    case "offline":
      return <OfflineIcon />;
    case "error":
      return <AlertCircleFilled fixed />;
    default:
      return null;
  }
};

const StatusLabel = props => {
  const statusClass = statuses.includes(props.status)
    ? "cb-c-status-label cb-c-status-label--" + props.status
    : "cb-c-status-label";

  return (
    <div
      className={`${statusClass} fable:bg-gray-50 fable:p-4 fable:text-sm fable:inline-block`}
    >
      <span className="fable:flex fable:items-center fable:px-2">
        {icon(props.icon) !== null && (
          <span className="cb-c-status-label__icon fable:flex fable:mr-4">
            {icon(props.icon)}
          </span>
        )}
        <span className="fable:flex">{props.label}</span>
      </span>
    </div>
  );
};

StatusLabel.propTypes = {
  status: PropTypes.oneOf(statuses),
  label: PropTypes.string,
  icon: PropTypes.oneOf(icons)
};

export default StatusLabel;
